import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AssistantState } from '../../shared/models/assistant.model';

export const selectAssistantState = createFeatureSelector<AssistantState>('assistant');

export const selectAssistantMessages = createSelector(
  selectAssistantState,
  (state: AssistantState) => state.messages
);

export const selectAssistantLoading = createSelector(
  selectAssistantState,
  (state: AssistantState) => state.loading
);

export const selectAssistantError = createSelector(
  selectAssistantState,
  (state: AssistantState) => state.error
);

export const selectConversations = createSelector(
  selectAssistantState,
  (state: AssistantState) => state.conversations
);

export const selectCurrentConversationId = createSelector(
  selectAssistantState,
  (state: AssistantState) => state.currentConversationId
);

export const selectConversationsLoading = createSelector(
  selectAssistantState,
  (state: AssistantState) => state.conversationsLoading
);

export const selectPendingWrite = createSelector(
  selectAssistantState,
  (state: AssistantState) => state.pendingWrite
);

export const selectAdminSessionId = createSelector(
  selectAssistantState,
  (state: AssistantState) => state.adminSessionId
);

export const selectAdminSessionState = createSelector(
  selectAssistantState,
  (state: AssistantState) => state.adminSessionState
);

export const selectAdminHistory = createSelector(
  selectAssistantState,
  (state: AssistantState) => state.adminHistory
);

export const selectPendingClarification = createSelector(
  selectAssistantState,
  (state: AssistantState) => state.pendingClarification
);
